import React from 'react'
import Modal from '../../Modal'
import "./style.css"
import { useLocation, useParams } from 'react-router-dom';

function CheckStatusModal({ show, close, statusList }) {
  const batchId = useParams().batchListId
  const batchid = useParams().batchid
  const location = useLocation()
  const lenderToSkip = process.env.REACT_APP_SKIP_LENDER_STATUS
    ? process.env.REACT_APP_SKIP_LENDER_STATUS.split(",")
    : [];
  return (
    <div>
      <Modal
        style={{
          minWidth: "20%",
          padding: "0px",
          backgroundColor: "transparent",
          width: '450px',
          minHeight: '100px'
        }}
        state={show}
        closeModal={close}
        removeBorderSpace={true}
      >
        <>
          <div className="modal-header-container">
            <div className="modal-title">Case Status</div>
            <div className="closeModalView" onClick={close}>
              <span className="closeModalIcon">x</span>
            </div>
          </div>
          <div className="p-4">
            <div className='row'>
              <div className="col-md-6 text-center">
                <h6 className='font-weight-bolder pb-2' style={{ borderBottom: '1px dashed #a3a2a2' }}>Lender name</h6>
              </div>
              <div className="col-md-6 text-center" >
                <h6 className='font-weight-bolder pb-2' style={{ borderBottom: '1px dashed #a3a2a2' }}>Status</h6>
              </div>
            </div>
            <div className='container-fluid px-0'>
              <div className="row">
                {statusList?.map(({ lender, cl_status, cl_lender_id, da_batch_id }) => {
                  console.log("da_batch_id ", da_batch_id);
                  if (
                    lenderToSkip.indexOf(String(cl_lender_id) || cl_lender_id) < 0
                  ) {
                    return lender?.lender_name.includes("Ugro Capital") ? (
                      ""
                    ) : (
                      location.pathname.includes('/da/') ?
                        (da_batch_id === parseInt(batchId) || da_batch_id === parseInt(batchid)) &&
                          <>
                            <div className="col-md-6 text-center">
                              <p>{lender?.lender_name}</p>
                            </div>
                            <div className="col-md-6 text-center">
                              <p>{cl_status?.alias_name?.[cl_lender_id] || cl_status?.admin_status}</p>
                            </div>
                          </>
                        :
                        <>
                          <div className="col-md-6 text-center">
                            <p>{lender?.lender_name}</p>
                          </div>
                          <div className="col-md-6 text-center">
                            <p>{cl_status?.alias_name?.[cl_lender_id] || cl_status?.admin_status}</p>
                          </div>
                        </>
                    );
                  } else {
                    return "";
                  }
                })}
              </div>
            </div>
          </div>
        </>
      </Modal>
    </div>
  )
}

export default CheckStatusModal